export default "__VITE_ASSET__BIOyeunL__"